import React from "react";
import LogoMark from "./LogoMark";

const Footer = () => {
  return (
    <footer className="site-footer">
      <a href="#" className="footer-logo">
        <LogoMark
          width={32}
          height={32}
          red="#F57F20"
          blue="#F57F20"
          orange="#F57F20"
          yellow="#F57F20"
        />
        <span className="footer-logo-text">Gauweng</span>
      </a>
      <div className="footer-copy">
        © 2026 Gauweng SA · Inspired Business Solutions · All rights reserved.
      </div>
      <div className="footer-links">
        <a href="#services">Services</a>
        <a href="#about">About</a>
        <a href="#why">Why Us</a>
        <a href="#contact">Contact</a>
      </div>
    </footer>
  );
};

export default Footer;
